






















import Vue from "vue";
// @ts-ignore
import { navigateToPath } from "@/util";
export default Vue.extend({
    data() {
        return {
            navBar: "home",
            is404: false
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.user;
        },
        showBarNav() {
            return this.$store.getters.barnav;
        }
    },
    methods: {
        navigateTo(path: string) {
            navigateToPath(path);
        }
    },
    mounted() {
        this.$router.afterEach((to, from) => {
            this.navBar = to.name ? to.name : "home";
        });
    }
});
